import { BaseListStore } from './baseListStore';
import { WallData } from '@/editor/data/wall/Wall';
import { AbstractBaseListStore } from './abstractBaseListStore';
import { SeparateWallBaseData, SeparateWallData, SeparateWallExtraData } from '@/editor/data/separateWall/SeparateWall';
import { EEntityType } from '@/editor/types';
import { TGlobalStores } from '..';
import { initDrawSeparateWallInfo } from '@/editor/data/separateWall/utils';

export class BaseSepStore implements AbstractBaseListStore<SeparateWallData> {
  private _sepBaseDataMap;
  private _sepExtraDataMap;

  constructor(gs: TGlobalStores) {
    this._sepBaseDataMap = new BaseListStore<SeparateWallBaseData>(gs, {
      keepOrder: true,
      dataType: EEntityType.SeparateWall
    });
    this._sepExtraDataMap = new Map<string, SeparateWallExtraData>();
  }

  add(_data: SeparateWallData) {
    const data: SeparateWallBaseData = {
      id: _data.id,
      start: _data.start,
      end: _data.end,
      thickness: _data.thickness,
      height: _data.height,
      offGround: _data.offGround,
      type: _data.type,
      relateRoomId: _data.relateRoomId,
      relativeWallId: _data.relativeWallId,
      relativeWallSide: _data.relativeWallSide,
      side: _data.side,
      startId: _data.startId,
      endId: _data.endId
    };
    if (_data.center) {
      data.center = _data.center;
      data.clockwise = _data.clockwise;
    }
    this._sepBaseDataMap.add(data);
    this._sepExtraDataMap.set(data.id, { drawSeparateWallInfo: _data.drawSeparateWallInfo });
  }

  update(_id: string, _data: WallData) {
    console.warn('can not update separate wall data directly');
  }

  updateBaseData(id: string, data: Partial<SeparateWallBaseData>) {
    if (!id || !data) return;

    const currentData = this._sepBaseDataMap.get(id);
    if (!currentData) return;

    this._sepBaseDataMap.update(id, data);
  }

  updateExtraData(id: string, data: SeparateWallExtraData) {
    if (!id || !data) return;
    this._sepExtraDataMap.set(id, { ...data });
  }

  remove(id: string) {
    if (!id || !this._sepBaseDataMap.get(id)) return;

    this._sepBaseDataMap.remove(id);
    this._sepExtraDataMap.delete(id);
  }

  get(id: string) {
    const baseData = this._sepBaseDataMap.get(id);
    if (!baseData) return;

    let extraData = this._sepExtraDataMap.get(id);
    if (!extraData) {
      extraData = {
        drawSeparateWallInfo: initDrawSeparateWallInfo({
          start: baseData.start,
          end: baseData.end,
          thickness: baseData.thickness,
          center: baseData.center,
          clockwise: baseData.clockwise
        })
      };
      this._sepExtraDataMap.set(id, extraData);
    }

    return {
      ...baseData,
      ...extraData
    };
  }

  getList() {
    return this._sepBaseDataMap
      .getList()
      .map((item) => this.get(item.id))
      .filter((item) => item !== undefined);
  }

  clear() {
    this._sepBaseDataMap.clear();
    this._sepExtraDataMap.clear();
  }
}
